import Gallery from "../../components/Gallery/Gallery";
import {makeStyles} from "@material-ui/core/styles";
import {Grid, Typography} from "@material-ui/core";
import {Helmet} from "react-helmet";
import {useEffect, useState} from "react";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: '85px',
    padding: '15px',
  }
}));

const Rome = () => {
  const classes = useStyles();
  const [images, setImages] = useState([]);

  useEffect(() => {
    fetch("/img/rome/rome.json")
      .then(response => {
        return response.json();
      })
      .then(data => {
        setImages(data);
      });
  }, [setImages]);

  return (
    <div className={classes.root}>
      <Helmet>
        <title>Rome 2024 | Thomas Bezuidenhout</title>
      </Helmet>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography variant="h1" align="center">
            The Eternal City
          </Typography>
          <Typography gutterBottom={true} align="center">
            We went on a holiday to Rome in November of 2024; here are the results. 
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Gallery images={images} />
        </Grid>
      </Grid>
    </div>
  )
};

export default Rome;
